export default "__VITE_ASSET__Erk0Jo0A__"